import { useContext } from 'react'
import { AppContext, AppContextType } from '../AppContext'
import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import CrossPlatformDialog from './components/CrossPlatformDialog'
import { DialogBody, DialogTitle } from '@/components/Dialog'
import StatusErrorIcon from '@/CustomIcons/StatusErrorIcon'

export default function DeviceResolutionErrorDialogController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const data = appState.appState.showAudioInputDeviceResolutionErrorDialog

    const onClose = () => {
        appDispatch({
            type: 'update_app_state',
            value: { showAudioInputDeviceResolutionErrorDialog: null },
        })
    }

    if (!data) {
        return null
    }

    return (
        <CrossPlatformDialog frameName={`Dialog:deviceResolutionError`} onDefaultClose={onClose}>
            <DialogBody>
                <div className="flex items-center gap-2 pb-4">
                    <StatusErrorIcon />
                    <DialogTitle noPadding>Device Access Error</DialogTitle>
                </div>

                <div>{data.message}</div>
            </DialogBody>
            <DialogActionButtonsSection rightButtonText="OK" onRightButtonClicked={onClose} />
        </CrossPlatformDialog>
    )
}
